import { IBookingQuestion } from "../../reducers/website/types";

export const SET_PREBOOKING_QUESTIONS = "SET_PREBOOKING_QUESTIONS";
interface ISetPreBookingQuestions {
  payload: IBookingQuestion[];
  type: typeof SET_PREBOOKING_QUESTIONS;
}

export type SetPreBookingQuestions = ISetPreBookingQuestions;
